/**
 * @file
 * 5 stars formatting inside product template.
 */

const $reviewsSummary = $('.product-reviews-summary', context);

$reviewsSummary.once('review-summary').each((index, el) => {
  const $this = $(el);
  const $stars = $this.find('.stars');
  const averageVote = $stars.data('vote-average');

  // Round the average number for data-vote-average-rounded attribute.
  const isFloat = n => n === +n && n !== (n|0);
  const averageVoteRounded = isFloat(averageVote)
    ? parseFloat(averageVote).toFixed(1)
    : parseInt(averageVote, 10);

  // Uses in css to display the average number.
  $stars.attr('data-vote-average-rounded', averageVoteRounded);

  function populateStars(stars, score) {
    const wholeStars = Math.floor(score);
    const halfStar = wholeStars < score;

    for (var star = 1; star <= wholeStars; star++) {
      $this.find(`.star-${star}`, stars).addClass('full');
    }

    if (halfStar) {
      $this.find(`.star-${star}`, stars).addClass('half');
    }
  }

  populateStars($this, averageVote);
});

// Transform Vote select field into 5 stars widget.
const $voteField = $('[id^=edit-field-review-vote].form-select', context);

$voteField.once('vote-field-transform').each((index, el) => {
  const $this = $(el);

  if (!$('.five-star-error').length) {
    $this.after(
      `<div class="five-star-error" hidden>
        ${Drupal.t('Please select vote rating.')}
      </div>`
    );
  }

  // Init 5 stars script.
  $this.barrating({
    theme: 'fontawesome-stars',
  });

  // Display error if all stars are empty.
  $('#comment-form').on('submit', event => {
    if ($this.val() === '_none') {
      event.preventDefault();
      const $errorMessage = $('.five-star-error');
      $errorMessage.slideDown();
    }
  });
});
